import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardTitle,
  Container,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Dropzone from "react-dropzone";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useSubmit } from "react-router-dom";
import useSubmitFile from "./useSubmit";
import useGetStatus from "./useGetStatus";
import { bool } from "prop-types";
import useGetProcessedFile from "./useGetProcessedFile";
import DeedDisplay from "./DeedDisplay";
import bgImgae from "../../assets/images/wp10581298-data-mining-wallpapers.jpg"
import Processing from "pages/Ui/Processing";
import FuzzyText from "pages/Ui/React-blits/FuzzyText";
import GradientText from "pages/Ui/React-blits/GradientText";
import { right } from "@popperjs/core";
import useGetPreSignedUrl from "./useGetPreSignedUrl";
import axios from "axios";

const FormUpload = ({ type,clearDataOnParentClose =false }) => {
  console.log("type:",type)
  // console.log("clearParentDataOnClose",clearDataOnParentClose)
  const [selectedFiles, setselectedFiles] = useState([]);
  const [error, setError] = useState("");
  const [orderId, setOrderId] = useState("");
  const [isTrue, setIsTrue] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [order,setOrder] = useState({})
  // count
  const tCount = JSON.parse(localStorage.getItem("count"))
  const[trialCount,setTrialCount]=useState(tCount);
  // console.log("trial Count:",trialCount);
  const[isCount,setIsCount]=useState(false);
  // console.log("isCount",isCount)

  // store data status
  const[isData,setIsData] = useState(null);
  // console.log("isData",isData)
  // store processedData
  const[isProcessedData,setIsProcessedData] = useState(null)
  // console.log("isProcessedData",isProcessedData)
  
  //state for dropzone enable and disable
  const[isDropzoneEnabled,setIsDropzoneEnabled]= useState(false)

   // State for the new upload flow
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({})

  
  const{isGetting,isGot,getPreSignedUrl}= useGetPreSignedUrl();
  const { isPending, isSuccess, upload } = useSubmitFile();
  const { isLoading, data, refetch} = useGetStatus(orderId);
  const{isFetching,processedData,refetchProcessed} = useGetProcessedFile(order);

  // console.log("on file submit:",isSuccess)
  // console.log(data)
  useEffect(() => {
    setError("");
  }, [selectedFiles]);

  useEffect(() => {
    if (isSuccess) {
      const timer = setTimeout(() => {
        const order = localStorage.getItem("sucessUploadData");

        if (order) {
          try {
            const parsedOrder = JSON.parse(order);
            if (parsedOrder?.length > 0) {
              setOrderId(parsedOrder[0].order_id);
            }
          } catch (error) {
            console.error("Error parsing order data:", error);
          }
        }
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isSuccess]);

  //new polling
  
   //polling intervals
   const pollingIntervals = [5000,20000,45000,120000,240000]

  useEffect(() => {
    if (!orderId) return;

    let step = 0;
    let intervalTime = pollingIntervals[step];
    let timer;

    const poll =()=>{
      refetch();
      
      if (
        data &&
        data.files &&
        data.processed_files === data.total_files &&
        data.files.every((file) => file.status === "processed")
      ) {
        clearTimeout(timer);
        setIsTrue(true);
        setOrderId("");
        setIsData(data);
        return;
      }
  
      if(
        data &&
        data.files &&
        data.processed_files !== data.total_files &&
        data.files.some((file) => file.status === "failed")
      ){
        clearTimeout(timer);
        setError("There was a problem processing your document. Please try again")
        return;
      }

      // stop polling after 240sec
      if(step===pollingIntervals.length - 1){
        clearTimeout(timer);
        setError("There was a problem processing your document. Please try again");
        return;
      }

      //moving to next interval
      step++;
      intervalTime = pollingIntervals[step];

      //schedule the next poll
      timer = setTimeout(poll,intervalTime);
    };

    //start polling
    timer = setTimeout(poll,intervalTime);

    return () => clearTimeout(timer);
  }, [orderId, data, refetch]);

  function handleAcceptedFiles(files) {
    const maxSize=20 * 1024 * 1024;
    const maxTCount= 10;

    const validFiles = [];

    for(const file of files){
      if(file.size > maxSize){
        setError(`File exceeds the maximum allowed size of 20MB`);
        return;
      }
      else{
        validFiles.push(file);
      }
    }

    if(validFiles.length>0){
      validFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        })
      );
    }

    setselectedFiles(validFiles);
    setIsDropzoneEnabled(!isDropzoneEnabled);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  // const handleSubmit = () => {
  //   if (selectedFiles.length === 0) {
  //     setError("Please upload a file");
  //     return;
  //   }
  //   if (selectedFiles.length > 10) {
  //     setError("Max upload limit is 10");
  //     return;
  //   }

  //   //validating with trial count
  //   const balCount = 10 - trialCount;
  //   // console.log("balCount",balCount)
  //   if(selectedFiles.length>balCount){
  //     setError(`Trial limit exceeded. You can upload up to ${balCount} files.`)
  //     return;
  //   }

  //   // getting presigned url

  //   const prospect = JSON.parse(localStorage.getItem("authUser"));
    
  //   const formData = new FormData();
  //   formData.append("project_type", type);
  //   formData.append("prospect_id", prospect?.prospect_id);
  //   formData.append("created_by", prospect?.prospect_id);

  //   selectedFiles.forEach((file) => {
  //     formData.append("file", file);
  //   });

  //   upload(formData,{
  //     onSettled:(uploadedData)=>  {
  //       // console.log("uploadedData",uploadedData)
  //       setTrialCount(uploadedData.order_count)
  //     }
  //   });
  // };

  // handle submit with presigned urls
  const handleSubmit = async () => {

  
  if (selectedFiles.length === 0) {
    setError("Please upload a file");
    return;
  }

  if (selectedFiles.length > 10) {
    setError("Max upload limit is 10");
    return;
  }

  const balCount = 10 - trialCount;
  if (selectedFiles.length > balCount) {
    setError(`Trial limit exceeded. You can upload up to ${balCount} files.`);
    return;
  }

  setIsUploading(true);
  const uploadedUrls = [];

  for (const file of selectedFiles) {
    const contentType = file.type || 'application/pdf';

    const formDataPreUrl = new FormData();
    formDataPreUrl.append('file_name',file.name)
    formDataPreUrl.append('content_type',contentType)

    // console.log("file_name",file.name)
    // console.log("content_type",contentType)
    try {
      await new Promise((resolve, reject) => {
        getPreSignedUrl(formDataPreUrl, {
          onSuccess: async (data) => {
            // console.log(data.url)
            // console.log(typeof(data.url))
            // console.log(data.gcsObjectName)

            try {
              // console.log("📤 Attempting PUT to GCS");
              const uploadResponse = await fetch(data.url, {
                  method: "PUT",
                  headers: {
                    "Content-Type": file.type || "application/pdf",
                  },
                  body: file
                });

              // console.log("first")
              // console.log("uploadResponse",uploadResponse)
              uploadedUrls.push(data.viewUrl); // collect uploaded urls
              resolve();
            } catch (err) {
              console.error("Upload error:", {
                    message: err.message,
                    responseData: err.response?.data,
                    responseStatus: err.response?.status,
                    headers: err.response?.headers
                  });
              setError(`Failed to upload ${file.name}`);
              reject();
            }
          },
          onError: (err) => {
            console.error("Presign error:", err);
            setError(`Failed to get upload URL for ${file.name}`);
            reject();
          }
        });
      });
    } catch (e) {
      console.warn(`Skipping file: ${file.name}`);
      continue;
    }
  }

  setIsUploading(false);

  //Once all files are uploaded to GCS, submit metadata using your existing upload()
  const prospect = JSON.parse(localStorage.getItem("authUser"));
  const formData = new FormData();
  formData.append("project_type", type);
  formData.append("prospect_id", prospect?.prospect_id);
  formData.append("created_by", prospect?.prospect_id);

  formData.append("file_url", JSON.stringify(uploadedUrls)); // uploadedUrls is an array


  upload(formData, {
    onSettled: (uploadedData) => {
      setTrialCount(uploadedData.order_count);
    }
  });
};

  const handleView = async (f) => {
    setModalOpen(true);
    // setModalLoading(true);
    
    try {
      const order = localStorage.getItem("sucessUploadData");
      if (!order) throw new Error("No upload data found");
      
      const parsedOrder = JSON.parse(order);
      const orderId = parsedOrder[0].order_id;
  
      // Keep the previous modalData if it exists
      // Only reset to null if the filename is different
      setOrder(prevOrder => {
        // If the filename is different, reset modalData
        if (prevOrder.filename !== f.name) {
          setModalData(null);
          setModalLoading(true);
        }
        
        // Always return the new order details
        return { orderId, filename: f.name };
      });
  
      await refetchProcessed();
      
    } catch (error) {
      console.error("Error fetching file data:", error);
      setModalLoading(false);
    }
  };
  
  useEffect(() => {
    if (processedData) {
      // Update modalData with new processedData
      setModalData(prevModalData => {
        // If previous data exists and new data is different, merge or update
        if (prevModalData && processedData) {
          // You can customize merging logic here if needed
          return {
            ...prevModalData,
            ...processedData
          };
        }
        
        // Otherwise, just set the new processedData
        return processedData;
      });
      
      setIsProcessedData(processedData);
      setModalLoading(false);
    }
  }, [processedData]);

  // useEffect(()=>{
  //   setIsProcessedData(null)
  // },[modalOpen])

  // for clearing the processedData after   closing parent modal
  useEffect(()=>{
    if(clearDataOnParentClose){
      setIsProcessedData(null)
    }
  },[clearDataOnParentClose])

  //for disabling the submit button
  useEffect(()=>{
    if(trialCount){
    const data_count = JSON.parse(localStorage.getItem("count"));
    // console.log(data_count)
    // console.log("on form upload:",data_count)
    const count = data_count
    setTrialCount(count)
    }
  },[trialCount])

  useEffect(()=>{
    if(trialCount){
      const trial = trialCount >= 10
      setIsCount(trial)
    }
  },[trialCount])
  // console.log(processedData)

  return (
    <React.Fragment>
      <div className="page-content" style={{marginTop:'0',paddingTop:'0px'}}>
      
        <Container fluid={true}>
          <Row>
          <Col className="col-12 d-flex justify-content-end text-center" style={{paddingRight:"20px"}}>
          {isTrue ? <div style={{fontSize:"15px", color:"white"}}>
                      Click here to view results
                      <i className="fas fa-arrow-down" style={{ display: "block", margin: "5px auto 0",paddingLeft:"80px"}}></i>
                  </div> : ""}
          </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="mb-5">
                    <Form>
                      {!isDropzoneEnabled && <Dropzone
                      accept={{'application/pdf':[]}}
                        onDrop={(acceptedFiles, rejectedFiles) => {
                          if(rejectedFiles.length>0){
                            setError("Please upload a file in PDF format.")
                            return;
                          }
                          handleAcceptedFiles(acceptedFiles);
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div className="dz-message needsclick" {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="mdi mdi-cloud-upload display-4 text-muted"></i>
                              </div>
                              <h4>Drop files here or click to upload.</h4>
                            </div>
                          </div>
                        )}
                      </Dropzone>}
                      <div className="dropzone-previews mt-3" id="file-previews" style={{maxHeight:"200px",overflowY:"auto",overflowX:"hidden"}}>
                        {selectedFiles.map((f, i) => {
                          return (
                            <Card className="mb-0 shadow-none border" key={i + "-file"}>
                              <div className="">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                  {/* <i className="mdi mdi-file-pdf-box text-danger" style={{ fontSize: "50px" }}></i> */}
                                  <i className="mdi mdi-file-pdf-outline text-danger" style={{ fontSize: "50px"}}></i>
                                  </Col>
                                  <Col>
                                    <p className="text-muted font-weight-bold mb-0">{f.name}</p>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                  </Col>
                                  <Col className="col-auto">
                                    {isSuccess ? (
                                      <Button
                                        disabled={!isTrue}
                                        color={isTrue ? "success" : "primary"}
                                        onClick={() => handleView(f)}
                                      >
                                        {!isTrue ? <Spinner type="grow" color="secondary" size="sm" /> : 'View'}
                                      </Button>
                                    ) : null}
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          );
                        })}
                      </div>
                    </Form>
                  </div>
                  <span className="text-danger text-center d-flex justify-content-center align-items-center">{error ? error : ""}</span>
                  {isCount ? <span className="text-danger text-break d-flex justify-content-center align-items-center"><p style={{fontSize:"13px"}}>Your free trial has expired.Please contact info@truefocusautomation.com</p></span> : ''}
                  {isSuccess && (!isTrue && orderId) ? <div className="d-flex flex-column justify-content-center align-items-center">
                    <GradientText
                      colors={["#40ffaa", "#4079ff", "#40ffaa", "#4079ff", "#40ffaa"]}
                      animationSpeed={3}
                      showBorder={false}
                      className="custom-class"
                      fntSize='22px'
                    >
                      Please wait here while your document is processing....
                    </GradientText>
                    <Processing/>
                  </div>:''}

                  {/* for uploading status */}
                  {isUploading ? <div className="d-flex flex-column justify-content-center align-items-center">
                    <GradientText
                      colors={["#40ffaa", "#4079ff", "#40ffaa", "#4079ff", "#40ffaa"]}
                      animationSpeed={3}
                      showBorder={false}
                      className="custom-class"
                      fntSize='22px'
                    >
                      Please wait your document is uploading....
                    </GradientText>
                    <Processing/>
                  </div>:''}
                  {isSuccess ? '' : <div className="text-center mt-4">
                    <button
                    style={{backgroundColor:"#00ADF0", color:"white"}}
                      type="button"
                      className="btn py-2"
                      onClick={handleSubmit}
                      disabled={isPending || isTrue || isCount || isGetting || isUploading}
                    >
                      {isPending ? <Spinner type="grow" color="secondary" size="sm" /> : "Submit"}
                    </button>
                  </div>}
                </CardBody>
              </Card>
            </Col>
            <Col>
              {/* <div className="text-end fs-6 fst-bold h3 text-white">Remaining Uploads: {Math.max(0,10-trialCount)}</div> */}
            </Col>
          </Row>
        </Container>

        {/* Modal */}
        
        <Modal isOpen={modalOpen} fullscreen scrollable backdrop="static" >
          <ModalHeader  style={{height:'80px',backgroundColor:'#626ed4'}}
            close={
              <button
              type="button" 
              className="btn-close" 
              style={{
              filter: 'invert(1)',
              opacity: 1,
              fontSize:'2rem',
              width:'80px'
              }}
              onClick={()=> setModalOpen(!modalOpen)}
              ></button>
            }
            ></ModalHeader>
          <ModalBody>
            {modalLoading ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : (
              // <pre>{JSON.stringify(modalData, null, 2)}</pre>
              <DeedDisplay data={modalData ? modalData : isProcessedData}
                type={type}/>
            )}
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default FormUpload;